import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "@/components/common/Buttons/Button";
import RadioButton from "@/components/common/Buttons/RadioButton";
import useNavigationHelpers from "@/hooks/useNavigationHelpers";
import { DeviceRole } from "@/types/device-role";

export const Route = createFileRoute("/$locale/$partner/_app/_card/select-scanner-device")({
	component: ScannerDeviceSelection,
});

function ScannerDeviceSelection() {
	const { t } = useTranslation();
	const { goToNextStep } = useNavigationHelpers();
	const [selectedOption, setSelectedOption] = useState<DeviceRole>();

	const options: Array<{ key: DeviceRole; content: JSX.Element }> = [
		{
			key: "evaluated",
			content: (
				<div className="flex flex-col">
					<h5 className="font-bold">{t("btn.Evaluate this device")}</h5>
					<h6>{t("btn.Grab a smartphone device to scan the one you are currently holding.")}</h6>
				</div>
			),
		},
		{
			key: "scanner",
			content: (
				<div className="flex flex-col">
					<h5 className="font-bold">{t("btn.Evaluate another device")}</h5>
					<h6>{t("btn.You will use this device as a scanner to perform the device evaluation.")}</h6>
				</div>
			),
		},
	];

	return (
		<div className="h-full w-full flex flex-col text-center items-center pt-10 sm:pt-20">
			<h3 className="whitespace-pre-line pb-8">{t("instructions.Which device do you want to evaluate?")}</h3>
			<div className="flex flex-col h-full justify-around overflow-y-auto pb-16">
				<div className="min-h-60 lg:min-h-96 max-h-[40dvh] w-full relative">
					<img
						src={`/images/scanner-device-selection.png`}
						alt="devices"
						className="w-full h-full object-contain"
					/>
				</div>
				<div className="flex flex-col gap-2 text-left py-6">
					<RadioButton
						themeMode="light"
						value={selectedOption}
						onChange={setSelectedOption}
						options={options}
					/>
				</div>
			</div>
			<div className="absolute bottom-0 left-0 bg-fixed-buttons w-full items-center flex flex-col-reverse sm:flex-row flex-wrap justify-center gap-2 lg:gap-4 mt-auto pb-6 sm:pb-10">
				<Button
					label={t("btn.Continue")}
					disabled={selectedOption === undefined}
					onClick={() => {
						if (!selectedOption) return;

						goToNextStep({ "device-role": selectedOption });
					}}
				/>
			</div>
		</div>
	);
}
